package uz.mint.frontend.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import uz.mint.frontend.PageGutter
import uz.mint.frontend.ShellStyle
import uz.mint.frontend.i18n.SiteStrings
import uz.mint.frontend.toSitePalette
import uz.mint.frontend.alignItems
import uz.mint.frontend.alignSelf
import uz.mint.frontend.flexWrapCss
import uz.mint.frontend.gridTemplateColumnsCss
import uz.mint.frontend.justifyContent
import uz.mint.frontend.marginInlineAuto
import uz.mint.frontend.placeItems
import uz.mint.frontend.widthCss
import com.varabyte.kobweb.compose.css.WhiteSpace

@Composable
fun ClosingCta(strings: SiteStrings) {
    val palette = ColorMode.current.toSitePalette()

    Div(
        Modifier
            .fillMaxWidth()
            .backgroundColor(palette.mint).color(palette.onMint)
            .borderBottom(2.px, LineStyle.Solid, palette.rule)
            .toAttrs()
    ) {
        Row(
            ShellStyle.toModifier()
                .padding(topBottom = clamp(48.px, 5.4.vw, 88.px), leftRight = PageGutter)
                .gap(32.px).flexWrapCss(),
            verticalAlignment = Alignment.Bottom,
        ) {
            Column(Modifier.gap(18.px)) {
                H2(
                    Modifier.fontSize(clamp(36.px, 5.6.vw, 82.px)).lineHeight(0.98)
                        .letterSpacing((-0.04).em).fontWeight(FontWeight.ExtraBold).toAttrs()
                ) {
                    SpanText(strings.ctaTitle1)
                    Br()
                    SpanText(strings.ctaTitle2)
                }
                P(
                    Modifier.fontSize(clamp(16.px, 1.3.vw, 19.px)).maxWidth(26.em)
                        .fontWeight(FontWeight.Medium).toAttrs()
                ) { SpanText(strings.ctaSub) }
            }

            Spacer()

            // Fixed ink/white rather than palette tokens: this button always sits on mint, so
            // it must not invert with the theme the way solidBg does.
            Link(
                path = "#$TARIFFS_ANCHOR",
                modifier = Modifier
                    .backgroundColor(Color.rgb(0x0F2620)).color(Colors.White)
                    .whiteSpace(WhiteSpace.NoWrap)
                    .fontWeight(FontWeight.Bold).fontSize(17.px)
                    .padding(topBottom = 19.px, leftRight = 32.px),
                variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
            ) { SpanText(strings.ctaBtn) }
        }
    }
}
